export const bankItems = [
    {
        src: '/assets/images/bank/Banking.svg',
        title: 'Manage Fiat Assets',
        text: 'An integrated banking functionality enables you to manage both your crypto and fiat at the same time.',
        id: 'changex_Banking'
    },
    {
        src: '/assets/images/bank/SEPA.svg',
        title: 'Easy SWIFT & SEPA Transactions',
        text: 'Receive your salary, send money to your family, and perform international transactions.',
        id: 'changex_SEPA'
    },
    {
        src: '/assets/images/bank/Safety.svg',
        title: 'Security first',
        text: 'Changex partners with a licensed agent of an Electronic Money Institution in order to ensure a safe and seamless environment for your fiat assets.',
        id: 'changex_safety'
    }
]

export const bankContent = {
    head2: 'Move Fiat Internationally',
    head3: 'Crypto-friendly banking for the new age',
    paragraph: 'Оbtain а bank account in multiple currencies including EUR, USD, or GBP to exchange crypto for fiat, and move it anywhere in the world through SEPA and SWIFT transfers.',
    firebasePage: "https://whitepaper.changex.io/",
    route: false,
    component: "bank"
}

export const heroObj = {
    titleObj: {
        h1: "Banking For The Digital Age",
        h2: "A Crypto-Friendly Bank With A DeFi Core",
        h3: "Changex enables users to efficiently manage fiat assets and easily cash out on crypto via connected Crypto Debit Cards and IBANs."
    },
    text: "",
    appBtnsVisible: false,
    scrollBtnText: "Discover Bank",
    scrollToID: "changex_wall",
    backgroundImage: '',
    class: 'hero-bank',
    perksArray: [
        {
            src: '/assets/images/bank/Banking.svg',
            title: 'Manage Fiat Assets',
            text: 'An integrated banking functionality enables you to manage both your crypto and fiat at the same time.'
        },
        {
            src: '/assets/images/bank/SEPA.svg',
            title: 'Easy SWIFT & SEPA Transactions',
            text: 'Receive your salary, send money to your family, and perform international transactions.'
        },
        {
            src: '/assets/images/bank/Safety.svg',
            title: 'Security first',
            text: 'Changex partners with a licensed agent of an Electronic Money Institution in order to ensure a safe and seamless environment for your fiat assets.'
        }
    ]
}

export const sliderTextData = {
    background: 'background-color-green',
    head: 'COMING SOON',
    h1: "Discover Better Fiat With Changex Banking",
    h2: "",
    h3: "Opening a bank account with Changex happens in seconds and gives you access to a suite of financial services and perks for an easier life.",
    button: true,
    route: false,
    buttonTxt: "Read Whitepaper",
    buttonUrl: "https://whitepaper.changex.io/"

}

export const cardDataDataBankPage = [
    {
        id: "Tab1",
        src: "/assets/images/bank/Banking.svg",
        title: "An Alternative to Banks",
        alt: "An Alternative to Banks",
        text: "Changex will operate as a licensed agent of an Electronic Money Institution (EMI). EMIs are safe, flexible, and compliant with all international legal frameworks and requirements.",
        linkText: "Discover Staking",
        url: ""
    },
    {
        id: "Tab2",
        src: "/assets/images/bank/SEPA-Transfer.svg",
        title: "Better, Faster, Smarter",
        alt: "Better, Faster, Smarter",
        text: "Get your IBAN in a few clicks and enjoy Euro banking in the 36 SEPA countries. Join a network of 500+ million users and vendors, send and receive Euro, and make payments in seconds.",
        linkText: "Discover Leveraged Staking",
        url: ""
    },
    {
        id: "Tab3",
        src: "/assets/images/bank/Currencies.svg",
        title: "Seamless Fiat To Crypto",
        alt: "Seamless fiat to crypto",
        text: "Access fiat-crypto synergies no traditional bank will offer. Turn fiat to crypto, sell crypto for fiat, and use all your assets in your daily activities with unprecedented ease.",
        linkText: "Discover Lending",
        url: ""
    }
]


export const cardContent = {
    head1: "Meet The",
    head2: "Changex",
    head3: "Debit Card",
    paragraph: 'A centrally-issued bank card that works with your decentralized tokens.',
    page: 'Bank'
}

export const thoughtObj = {
    page: 'Bank',
    className: "bankThought",
    title: 'Spend',
    image: '/assets/images/bank/bank_0.webp',
    link: '',
    p1:  'The Changex crypto debit card works like a standard debit card in any location that supports cashless payments.',
    p2:  ' Use Euro or any in-app token in the real world and unchain your personal finance.'
}


export const sliderThoughtData = [
    {
        id: "Tab1",
        image: "/assets/images/bank/bank_0.webp",
        head: "Spend",
        alt: "spend",
        p1: "The Changex crypto debit card works like a standard debit card in any location that supports cashless payments.",
        p2: "Use Euro or any in-app token in the real world and unchain your personal finance.",
        linkText: "",
        url: "#"
    },
    {
        id: "Tab2",
        image: "/assets/images/bank/bank_1.webp",
        head: "Earn",
        alt: "earn",
        p1: "Get crypto or Euro cashback every time you use your card for purchases.",
        p2: "Increase the percentage and get more out of your bank account by holding and/or staking more CHANGE.",
        linkText: "",
        url: "#"
    },
    {
        id: "Tab3",
        image: "/assets/images/bank/bank_2.webp",
        head: "Stay flexible",
        alt: "flexible",
        p1: "Use your virtual debit card in the app and spend securely, or spend Euro and any in-app token with the physical card.",
        p2: "Simply pick your currency - Changex handles everything in the background.",
        linkText: "",
        url: "#"
    }
]
